import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APP_SETTINGS } from '@services';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

import { catchError, map } from 'rxjs/operators';
import { AnalyticsService } from '../services/analytics/analytics.service';
@Injectable()
export class WebApiBaseURLInterceptor implements HttpInterceptor {

  className = "WebApiBaseURLInterceptor";

  constructor(private analyticsService: AnalyticsService) {
    let isMini = '';
    let windowUrl = window.location.protocol + '//' + window.location.host + ':' + window.location.port + '/';
    if (APP_SETTINGS.isMINI === 'true') {
      isMini = windowUrl + '?linemake=MINI';
    } else {
      isMini = windowUrl + '?linemake=BMW';
    }

    // in future please keep adding more http options info here like OAuth2 access token
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
  }

  /**
   *
   * @param {HttpRequest<any>} req
   * @param {HttpHandler} next
   * @returns {Observable<HttpEvent<any>>}
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // the baseURL is being set in environment folder which has both Dev and Prod
    let brand = '';
    // let windowUrl = window.location.protocol + '//' + window.location.host + '/';
    if (APP_SETTINGS.isMINI === 'true') {
      brand = 'MINI';
    } else if (APP_SETTINGS.isBMW === 'true') {
      brand = 'BMW';
    } else if (APP_SETTINGS.isMOTORRAD === 'true') {
      brand = 'MOTORRAD';
    } else {
      brand = 'BMW';
    }

    const url = environment.baseUrl;
    req = req.clone({
      setHeaders: {
        'Brand': brand
      },
      url: url + req.url
    });
    // return next.handle(req);

    // lets add elapse time difference
    const started = Date.now();

    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          const elapsed = Date.now() - started;
        }
        //this.analyticsService.trackErrorByLineMake('400', 'System Error');
        return event;
      }),
      catchError((error: HttpErrorResponse) => {

        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
          // client-side error
          console.error('Client-side error WebApiBaseURLInterceptor error--->>>', error);
          errorMessage = `Error: ${error.error.message}`;
          this.analyticsService.trackErrorByLineMake(error.status.toString(), errorMessage);
        } else {
          // server-side error
          console.error('Server-side error WebApiBaseURLInterceptor error--->>>', error);
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
          if (error.status !== 200) {
            this.analyticsService.trackErrorByLineMake(error.status.toString(), errorMessage);
          }
        }
        return throwError(error);
      }));
  }
}